import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Item_Seleccion } from 'src/app/models/generic/Item_Seleccion';
import { ConfiguracionService } from 'src/app/services/configuracion.service';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { MenuService } from 'src/app/services/menu.service';
import { ProductosService } from 'src/app/services/productos.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';

@Component({
  selector: 'adicionar-items-lista',
  templateUrl: './adicionar-items-lista.component.html',
  styleUrls: ['./adicionar-items-lista.component.scss']
})
export class AdicionarItemsListaComponent implements OnInit{
  @Input() TituloMostrar: string = 'Valores disponibles';
  @Input() TextoSiMostrar: string = 'Aceptar';
  @Input() TextoNoMostrar: string = 'Cancelar';
  @Input() CodigoLlamado: string = '';
  @Input() CaracterSeparacionRegistro: string = '|';
  @Output() ConfirmoUsuario: EventEmitter<string>;
  @ViewChild('modalconfirmacionitems', {static: false}) _ModalConfirmacion: TemplateRef<any>;
  @ViewChild('itemID') inputItemId: ElementRef;
  _ListaItemsSeleccion: Item_Seleccion[] = [];
  _TextoSeleccion: string = '';
  form: FormGroup;
  
  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public menuService: MenuService,
    public productosService: ProductosService,
    public configuracionService: ConfiguracionService,
    public modal: MatDialog) {
      this.ConfirmoUsuario = new EventEmitter();
    }

  ngOnInit() {
    this.IniciarFormulario();
  }

  public MostrarEdicionItemsLista(textoProcesar: string) {
    this.IniciarFormulario();
    let confirmacionModal = this.modal.open(this._ModalConfirmacion, {
      width: '60%'
    });
    this._TextoSeleccion = textoProcesar;
    this.TransformarTextoALista();

    confirmacionModal.afterClosed().subscribe(valor => {
      if (valor) {
        let valorNotificar: string = this.TransformarListaATexto();
        this.ConfirmoUsuario.emit(valorNotificar);
      } else {
        this.ConfirmoUsuario.emit(this._TextoSeleccion);
      }
    });
  }

  IniciarFormulario() {
    this.form = this.fb.group({
      itemAdicionar: ['']
      ,descripcion: ['']
    });
  }
  TransformarTextoALista() {
    this._ListaItemsSeleccion = this.utilitariosService.TransformarTextoALista(this._TextoSeleccion, this.CaracterSeparacionRegistro);
  }
  EliminarItemLista(idItem: number) {
    this._ListaItemsSeleccion.splice(idItem, 1);
  }
  AdicionarItemLista() {
    if (this.utilitariosService.VerificarContieneDatosTexto(this.form.get('itemAdicionar').value)) {
      if (this._ListaItemsSeleccion.filter(x => x.id.toLowerCase() === this.form.get('itemAdicionar').value.toLowerCase()).length === 0) {
        let itemAdicionar: Item_Seleccion = new Item_Seleccion();
        itemAdicionar.id = this.form.get('itemAdicionar').value;
        itemAdicionar.descripcion = this.form.get('descripcion').value;
        this._ListaItemsSeleccion.push(itemAdicionar);
        this.form.get('itemAdicionar').setValue('');
        this.form.get('descripcion').setValue('');
        this.inputItemId.nativeElement.focus();
      }
    }
  }
  TransformarListaATexto(): string {
    let listaRetorno: string = '';
    for (let index = 0; index < this._ListaItemsSeleccion.length; index++) {
      if (this.utilitariosService.VerificarContieneDatosTexto(listaRetorno) === false) {
        listaRetorno = `${this._ListaItemsSeleccion[index].id}`;
      } else {
        listaRetorno = `${listaRetorno}${this.CaracterSeparacionRegistro}${this._ListaItemsSeleccion[index].id}`;
      }
    }
    
    return listaRetorno;
  }
  DescripcionItemsLista(item: Item_Seleccion): string {
    let retornoDescripcion: string = '';
    retornoDescripcion = `${item.id}`;
    return retornoDescripcion;
  }
}
